import { render } from "./CampaignSpecialAdCategoriesBlock.vue?vue&type=template&id=6d45dd14"
import script from "./CampaignSpecialAdCategoriesBlock.vue?vue&type=script&lang=js"
export * from "./CampaignSpecialAdCategoriesBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/CampaignSpecialAdCategoriesBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d45dd14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d45dd14', __exports__)) {
    api.reload('6d45dd14', __exports__)
  }
  
  module.hot.accept("./CampaignSpecialAdCategoriesBlock.vue?vue&type=template&id=6d45dd14", () => {
    api.rerender('6d45dd14', render)
  })

}


export default __exports__